import { render, staticRenderFns } from "./ProductStockSummary.vue?vue&type=template&id=3048cead&scoped=true"
import script from "./ProductStockSummary.vue?vue&type=script&lang=js"
export * from "./ProductStockSummary.vue?vue&type=script&lang=js"
import style0 from "./ProductStockSummary.vue?vue&type=style&index=0&id=3048cead&prod&lang=css"
import style1 from "./ProductStockSummary.vue?vue&type=style&index=1&id=3048cead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3048cead",
  null
  
)

export default component.exports